<template>
  <div class="walletPay">
    <div class="payInfo">
      <span>充值金额</span>
      <van-field label="¥" placeholder="请输入充值金额" readonly clickable :value="query.account"  @touchstart.native.stop="show = true" />
      <van-number-keyboard v-model="query.account" theme="custom" extra-key="." :show="show" close-button-text="充值" @blur="pay" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {
    Toast
  } from 'vant';
  import {
    NumberKeyboard
  } from 'vant';
    import { mySessionStorage } from '@/utils/storage.js'
  Vue.use(NumberKeyboard, Toast);
  export default {
    name: "appeal",
    data() {
      return {
        show: false,
        carImgUrl: "../static/img/adsence1.jpg",
        cz: "../static/img/cz.png",
        query: {
          openid:"",
          userId: "",
          account: ""
        }
      };
    },
    methods: {
      pay() {
        if(this.query.account<0.01){
          Toast.fail("金额最小为0.01")
          return
        }
        this.show = false;
        this.$http.post(this.$api.recharge, {
          ...this.query
        }).then(res => {
          this.$WXjsSDK(res.data,res.msg,"wallet",this.query.account);
        });
      },
    },
    created() {
      this.query.userId = this.$route.query.userId;
      this.query.openid=mySessionStorage.getItem("openid");
    }
  };
</script>

<style scoped>
  .walletPay {
    background-color: white;
    height: 100%;
    width: 100%;
  }

  .payInfo {
    font-size: 2em;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/wallet/walletPay.vue